import React, { useEffect, useState } from 'react'
import { checkForGlobalLogin } from '../../lib/utils'
import AuthorView from './Author'

const WritersBenefit = (props) => {
  const [countryCode, setCountryCode] = useState('')

  useEffect(() => {
    checkForGlobalLogin()
      .then((result) => {
        setCountryCode(result?.countryCode)
      })
      .catch((err) => console.log(err))
  }, [])

  return <AuthorView {...props} countryCode={countryCode} />
}

export default WritersBenefit
